module.exports = __webpack_public_path__ + "1927d973d4aecffe05e2457a0707077b.svg";